module.exports = "input[type=\"file\"] {\n  display: none; }\n\n.input-label {\n  margin-left: 5px; }\n"